import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthStorage } from "../auth/storage/auth-storage";
import { UserRole } from "../shared/interfaces/auth.interface";

export function permissionGuard(allowedRoles: UserRole[]): CanActivateFn {
  return () => {
    const router = inject(Router);
    const authStorage = inject(AuthStorage);

    const user = authStorage.user();
    if (user && allowedRoles.includes(user.role)) {
      return true;
    }
    return router.createUrlTree(["/admin/dashboard"]);
  };
}
